document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('SearchInput');
  const searchResults = document.getElementById('SearchResults');

  const searchIcon = document.querySelector('.search-icon');
if (searchIcon) {
  searchIcon.addEventListener('click', function(e) {
    const query = searchInput.value.trim();
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    }
  });
}
  
  let debounceTimer;
  
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    
    clearTimeout(debounceTimer); // Clear previous timer
    
    if (query === '') {
      searchResults.style.display = 'none';
      return;
    }
    
    // Show loading state
    searchResults.innerHTML = '<div class="search-loading">Searching...</div>';
    searchResults.style.display = 'block';
    
    debounceTimer = setTimeout(() => {
      fetchSearchResults(query);
    }, 300); // Wait 300ms after typing stops
  });
  
  // Close results when clicking outside
  document.addEventListener('click', function(e) {
    if (!searchResults.contains(e.target) && e.target !== searchInput) {
      searchResults.style.display = 'none';
    }
  });
  
  // Keyboard navigation (Arrow Up/Down + Enter)
  searchInput.addEventListener('keydown', function(e) {
    const items = searchResults.querySelectorAll('.search-result-item');
    let currentItem = document.querySelector('.search-result-item.highlighted');
    
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!currentItem) items[0]?.classList.add('highlighted');
      else {
        currentItem.classList.remove('highlighted');
        const nextItem = currentItem.nextElementSibling || items[0];
        nextItem.classList.add('highlighted');
        nextItem.scrollIntoView({ block: 'nearest' });
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (currentItem) {
        currentItem.classList.remove('highlighted');
        const prevItem = currentItem.previousElementSibling || items[items.length - 1];
        prevItem.classList.add('highlighted');
        prevItem.scrollIntoView({ block: 'nearest' });
      }
    } else if (e.key === 'Enter' && currentItem) {
      e.preventDefault();
      currentItem.querySelector('a')?.click();
    }
  });
  
  function fetchSearchResults(query) {
    fetch(`/search?q=${encodeURIComponent(query)}&type=product&view=ajax`)
      .then(response => {
        if (!response.ok) throw new Error('Network error');
        return response.text();
      })
      .then(data => {
        searchResults.innerHTML = data;
        searchResults.style.display = 'block';
      })
      .catch(error => {
        searchResults.innerHTML = '<div class="search-error">Failed to load results</div>';
        console.error('Search error:', error);
      });
  }
});